import React from 'lib/react';
import {
  Route, Switch, useLocation, useHistory,
} from 'lib/router';
import { DASHBOARD_ROUTE, ORDER_HISTORY_ROUTE } from 'constants/RouteConstants';
import useMediaQuery from 'hooks/useMediaQuery';
import { STANDALONE_PAGES } from 'constants/AppConstants';
import {
  EVLink, EVArrowDown,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import { isAuthorized } from 'utils/auth.utils';
import HeaderStyles from '../HeaderStyles';
import EVLogoButton from './EVLogoButton.component';

function RenderBackLink({ route, name }) {
  const history = useHistory();
  const classes = HeaderStyles();
  return (
    <EVLink onClick={() => history.push(route)} className={classes.dasboardHeaderLink}>
      <EVArrowDown className={classes.backIcon} />
      {name}
    </EVLink>
  );
}

function BackNavigationLink() {
  const isMobile = useMediaQuery(640);
  const { t } = useTranslation();
  const location = useLocation();

  if (!isAuthorized() || !isMobile || STANDALONE_PAGES.includes(location.pathname)) {
    return (
      <EVLogoButton />
    );
  }

  return (
    <Switch>
      <Route
        path={`${ORDER_HISTORY_ROUTE}/*`}
        render={() => <RenderBackLink route={ORDER_HISTORY_ROUTE} name={t('common__order_history')} />}
      />
      <Route
        render={() => <RenderBackLink route={DASHBOARD_ROUTE} name={t('Dashboard')} />}
      />
    </Switch>
  );
}
RenderBackLink.propTypes = {
  route: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default BackNavigationLink;
